var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"evaluation-result",class:{ checkapp: _vm.platform === 'checkapp' }},[_c('div',{staticClass:"evaluation-wrap"},[_c('div',{staticClass:"evaluation-result-icon success"}),_c('div',{staticClass:"result-info"},[_c('header',[_vm._v("评价成功")]),_c('p',[_vm._v(_vm._s(`感谢您对${_vm.platform === 'checkapp' ? '切克' : '转转'}的支持`))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }